/**
 * useCart Hook - Convenient access to cart operations
 * Phase C2: Cart Frontend State
 * 
 * Usage:
 * ```
 * import { useCart } from '../hooks/useCart';
 * 
 * function MyComponent() {
 *   const { cartItems, itemCount, totalPrice, addToCart, removeItem } = useCart();
 *   
 *   return (
 *     <div>
 *       <p>Cart: {itemCount} items (${totalPrice.toFixed(2)})</p>
 *       <button onClick={() => addToCart(productId, 1)}>Add to Cart</button>
 *     </div>
 *   );
 * }
 * ```
 */

import { useContext } from 'react';
import CartContext from '../contexts/CartContext';

export const useCart = () => {
  const context = useContext(CartContext);
  
  if (!context) {
    throw new Error('useCart must be used within a CartProvider');
  }
  
  return context;
};

export default useCart;
